const LABEL_LEGEND_TYPE = {
  DIET: 'diet',
  ALLERGEN: 'allergen',
}

export default LABEL_LEGEND_TYPE
